import { FaIcon, faPrint } from '@/lib/fa'
import Tooltip from '@/modules/drivers/shared/ToolTip'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import * as React from 'react'

interface Props {
  tooltip?: string
  onClick: () => void
  disabled?: boolean
  blockedText?: string
}

export const PrintActionButton: React.FC<Props> = ({
  tooltip,
  onClick,
  disabled,
  blockedText,
}) => {
  const { t } = useLocalize()
  const resolvedTooltip = tooltip ?? t('printout.print-reports')
  return (
    <Tooltip
      text={resolvedTooltip}
      onClick={onClick}
      disabled={disabled}
      blockedText={blockedText}
    >
      <div className="tw-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center tw-rounded-lg hover:tw-bg-[#e5e6e6]">
        <FaIcon icon={faPrint} className="tw-h-4 tw-w-4 tw-text-[#2448bb]" />
      </div>
    </Tooltip>
  )
}
